import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { cn } from '../../lib/utils';

/**
 * Cycles through words with a blur-slide transition. The passed `className`
 * (e.g. the gradient `text-flow`) is applied to the SAME element that holds the
 * text — applying a `background-clip: text` gradient to an ancestor while the
 * text lives in a transformed child renders transparent (invisible).
 */
export default function RotatingText({ words = [], interval = 2200, className }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (words.length < 2) return;
    const id = setInterval(() => setI((p) => (p + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [words.length, interval]);

  return (
    <span className="relative inline-grid align-bottom">
      <AnimatePresence mode="popLayout">
        <motion.span
          key={i}
          initial={{ y: '0.7em', opacity: 0, filter: 'blur(8px)' }}
          animate={{ y: 0, opacity: 1, filter: 'blur(0px)' }}
          exit={{ y: '-0.7em', opacity: 0, filter: 'blur(8px)' }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className={cn('col-start-1 row-start-1 whitespace-nowrap pb-[0.08em]', className)}
        >
          {words[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
